export default function handleValidate(value) {
  if (value === '' || value === false) {
    return false;
  }

  return true;
}
